// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

const apiBaseUrl = import.meta.env.VITE_GYMING_API_BASE_URL;

// Defensive runtime check: this should never happen if build validation works correctly
if (apiBaseUrl === undefined || apiBaseUrl === null || apiBaseUrl === '') {
  console.error(
    '[Environment Error] VITE_GYMING_API_BASE_URL is undefined. This indicates a build configuration issue.\n' +
      'The build should have failed during compilation. Please check vite.config.ts and ensure .env files are properly configured.'
  );
}

import { getAppWebBaseUrl } from '@/services/app-web-base-url';

export default {
  isProd: import.meta.env.PROD,
  isDev: import.meta.env.DEV,
  apiBaseUrl,
  name: import.meta.env.VITE_ENVIRONMENT,
  version: import.meta.env.APP_VERSION,
  liveUpdateBaseUrl: import.meta.env.VITE_LIVE_UPDATE_BASE_URL,
  appWebBaseUrl: getAppWebBaseUrl(),
};
